module.exports = __webpack_public_path__ + "static/img/Qsama_logo.39fa20b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/Qsama_logo.png
// module id = 4D6s
// module chunks = 0